import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "145.333",
  height: "210.667",
  version: "1.0",
  viewBox: "0 0 109 158"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 24.8v24.9l8.5 7.7 8.5 7.8v60.4l-8.5 7.8-8.5 7.7V158h109v-16.5l-8.5-7.8-8.5-7.8V65.2l8.5-8 8.5-8.1V0H88v16H65V0H44v16H21V0H0zm62.9 53.9c1.4 1.1 3.6 3.9 4.9 6.4 2.1 4.2 2.2 5.4 2 22.4l-.3 18-15.2.3-15.3.3v-18.5c0-19.1.5-22.3 4.3-26.5 4.9-5.3 14-6.4 19.6-2.4" }, null, -1)
  ]))]))
}
export default { render: render }